import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useCreateMaxLessonsPerDayMutation, type MaxLessonsPerDay } from 'shared/api';

interface UseMaxLessonsPerDayCopyProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const useMaxLessonsPerDayCopy = ({
  maxLessonsPerDay,
  refreshTable,
}: UseMaxLessonsPerDayCopyProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = useAppForm<MaxLessonsPerDay>();
  const [createMaxLessonsPerDay] = useCreateMaxLessonsPerDayMutation();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(maxLessonsPerDay);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await form.validateFields().then(async (values) => {
      await createMaxLessonsPerDay(values)
        .unwrap()
        .then(() => {
          hideModal();
          refreshTable();
        });
    });
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
